// Convite da transportadora pelo embarcador (PO1-2299). Backend: backend_hub,
// módulo onboarding-transportadora. Escopo do embarcador é checado no servidor.
import api from "./api";

export async function criarConvite({ embarcadorId, transportadoraId, cnpj, email, nome }) {
  const { data } = await api.post("/transportadoras/convites", { embarcadorId, transportadoraId, cnpj, email, nome });
  return data;
}

export async function reenviarConvite({ conviteId, embarcadorId }) {
  const { data } = await api.post(`/transportadoras/convites/${conviteId}/reenviar`, { embarcadorId });
  return data;
}

export async function cancelarConvite({ conviteId, embarcadorId }) {
  const { data } = await api.delete(`/transportadoras/convites/${conviteId}`, { params: { embarcadorId } });
  return data;
}

// Convites em curadoria Everlog (ou recusados nos últimos 30 dias) do embarcador.
export async function listarConvitesCuradoria({ embarcadorId }) {
  const { data } = await api.get("/transportadoras/convites", { params: { embarcadorId, situacao: "curadoria" } });
  return data;
}

// Contato do vínculo para pré-preencher o e-mail (TI > Logística > Cotação).
export async function sugestaoEmailConvite({ embarcadorId, transportadoraId }) {
  const { data } = await api.get("/transportadoras/convites/sugestao-email", { params: { embarcadorId, transportadoraId } });
  return data;
}
